import React from 'react';
import { NavLink } from 'react-router-dom';

export const SearchBreadcrumb = ({ filter, category }) => {
    return (
        <nav aria-label="breadcrumb">
            <div className="breadcrumb">
                <NavLink className="breadcrumb-item text-decoration-none" to="/">
                    Home
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/search">
                    Search
                </NavLink>
                {category && (
                    <NavLink
                        className="breadcrumb-item text-decoration-none"
                        to={`/search?filter=${category}`}>
                        {category}
                    </NavLink>
                )}
                {filter && (
                    <NavLink
                        className="breadcrumb-item text-decoration-none"
                        to={`/search?filter=${filter}`}>
                        {filter}
                    </NavLink>
                )}
            </div>
        </nav>
    );
};
